<template>
  <div class="content-wrapper">
    <div style="text-align:center;">
      <el-button type="primary"
        id="google-login-account-dialog"
        class="button-block"
         style="background-color:#fff;border-color:#000;color:#000;font-size: 22px;padding:10px 0;vertical-align:middle;"
        :plain="isPlainButton"
        @click="$firebase.signInGoogle();"><img src="/static/renew_img/icon/google.png" style="width:40px;vertical-align: middle;" >　Googleでログイン</el-button>
    </div>
    <br>
    <div style="text-align:center;">
      <el-button type="primary"
        class="button-block"
        id="google-login-account-dialog"
         style="background-color:#fff;border-color:#000;color:#000;font-size: 22px;vertical-align: middle;"
        :plain="isPlainButton"
        @click="$firebase.signInApple();"><img src="/static/renew_img/icon/appleinc.png" style="width:40px;vertical-align: middle;" >　AppleIDでログイン</el-button>
    </div>
    <br>
    <div style="text-align:center;">
      <el-button type="primary"
        class="button-block"
        id="google-login-account-dialog"
         style="background-color:#fff;border-color:#000;color:#000;font-size: 22px;vertical-align: middle;"
        :plain="isPlainButton"
        @click="$firebase.signInFacebook();"><img src="/static/renew_img/icon/facebook.png" style="width:40px;vertical-align: middle;" >　Facebookでログイン</el-button>
    </div>
    <p><span></span>または<span></span></p>
    <el-form ref="mailLoginForm"
      :model='mailLogin'
      :rules='mailLoginRules'
      @submit.native.prevent>
      <div class="mail-input">
        <el-input v-model="mailLogin.email"
        type="email"
        autocomplete
        name="mail-link-input"
        placeholder="メールアドレスを入力してください"
        :disabled="loginEmailSending"></el-input>
      </div>
      <div class="btn_mail">
        <el-button type="primary"
          id="email-login-account-dialog"
          class="button-block"
          :plain="isPlainButton"
          style="border-color:#004D3F"
          @click="mailSubmit"
          v-loading="loginEmailSending">メールでリンクを送る</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    isPlainButton: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      loginEmailSending: false,
      mailLogin: {
        email: ''
      },
      mailLoginRules: {
        email: [
          {
            required: true,
            message: 'メールアドレスをいれてね',
            trigger: 'blur'
          },
          {
            required: true,
            type: 'email',
            message: 'メールアドレスをいれてね',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    resetloginEmail: function () {
      this.mailLogin.email = ''
      this.loginEmailSending = false
      this.$refs['mailLoginForm'].resetFields()
    },
    mailSubmit: function () {
      const app = this
      this.$refs['mailLoginForm'].validate(async valid => {
        if (!valid) {
          return
        }
        app.$firebase.signInEmail(app.mailLogin.email)
        app.loginEmailSending = true
      })
    }
  },
  mounted: function () {
    this.$eventHub.$on('sing-in-mail-send', this.resetloginEmail)
    this.$eventHub.$on('sing-in-mail-failed', this.resetloginEmail)
  },
  destroyed: function () {
    this.$eventHub.$off('sing-in-mail-send', this.resetloginEmail)
    this.$eventHub.$off('sing-in-mail-failed', this.resetloginEmail)
  }
}
</script>
